import React from 'react';
import { useNavigate } from 'react-router-dom'; 

const Header = ({ title, subtitle, children }) => {
    const navigate = useNavigate(); 

    return (
        <div className="header-container-white">
            <div className="custom-page-header">
                <div className="header-titles-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <button className="btn-back-header" onClick={() => navigate(-1)} title="Go Back">
                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    
                    <div className="header-titles">
                        <h1>{title}&nbsp;&nbsp;&nbsp;</h1>
                        {subtitle && <p className="page-subtitle">{subtitle}</p>}
                    </div>
                </div>
                
                {children && (
                    <div className="header-actions">
                        {children}
                    </div>
                )}
            </div>

            <style jsx>{`
                .header-container-white {
                    background-color: #ffffff;
                    padding: 15px 32px;
                    border-bottom: 1px solid #e2e8f0;
                    margin: -24px -24px 10px -24px; 
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }

                .custom-page-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                }

                .header-titles h1 {
                    margin: 0;
                    font-size: 1.5rem;
                    color: #111827;
                    font-weight: 700;
                }

                .page-subtitle {
                    margin: 4px 0 0 0;
                    font-size: 0.875rem;
                    color: #6b7280;
                }

                .header-actions {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                /* --- REDUCED HEIGHT FOR BACK BUTTON --- */
                .btn-back-header {
                    background-color: #f8fafc;
                    color: #64748b;
                    border: 1px solid #e2e8f0;
                    padding: 4px 8px; /* Reduced vertical padding */
                    height: 32px; /* Explicit smaller height */
                    border-radius: 8px; /* Slightly tighter radius to match the smaller size */
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                }

                .btn-back-header:hover {
                    background-color: #f1f5f9;
                    color: #1e293b;
                    border-color: #cbd5e1;
                }

                /* Mobile Responsiveness */
                @media (max-width: 768px) {
                    .custom-page-header {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                    .header-actions {
                        width: 100%;
                    }
                    .header-titles-wrapper {
                        margin-bottom: 0px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Header;